// Identity follows the source event, never just its caption: repeated journeys are distinct.
export function notificationKey(notification: any): string {
  const metadata = notification.metadata;
  if (notification.category === 'geofence' && metadata?.timestamp && metadata?.zoneId && metadata?.vehicleId) {
    const timestamp = new Date(metadata.timestamp).getTime();
    if (Number.isFinite(timestamp)) {
      return JSON.stringify([notification.title, String(metadata.vehicleId), String(metadata.zoneId), timestamp]);
    }
  }
  return String(notification.alertId || notification.metadata?.alertId || notification.id || notification._id);
}

export function mergeNotifications<T extends { id: string; timestamp: Date }>(items: T[]): T[] {
  const seen = new Set<string>();
  return items.filter(item => {
    const key = notificationKey(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
}
